export default __webpack_public_path__ + "static/media/uwaje.f9334185.jpg";